module.exports = __webpack_public_path__ + "static/media/subset-Roboto-Regular.66a2e9cc.woff2";